import {
  getAppControllerGetVersionQueryKey,
  useAppControllerGetVersion,
} from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { defineStore } from 'pinia';
import { computed } from 'vue';
import { usePiniaRefStore } from '../composables/usePiniaRefStore';
import { useResponseData } from '../composables/useResponseData';

export const useServerStatusStore = defineStore('server-status', () => {
  const {
    data,
    isError: versionError,
    dataUpdatedAt: serverStatusUpdatedAt,
    refetch: refetchServerStatus,
    isFetching: isFetchingServerStatus,
  } = useAppControllerGetVersion({
    query: {
      queryKey: getAppControllerGetVersionQueryKey(),
      refetchInterval: 30000,
      networkMode: 'offlineFirst',
    },
  });

  const versionData = useResponseData(data);

  const version = computed(() => versionData.value?.version);
  const serverConnected = computed(() => serverStatusUpdatedAt.value > 0);
  const serverDown = computed(() => !isFetchingServerStatus.value && !serverConnected.value);
  const serverHealthy = computed(() => serverConnected.value && !versionError.value);

  return {
    version,
    serverHealthy,
    serverConnected,
    serverDown,
    isFetchingServerStatus,
    serverStatusUpdatedAt,
    refetchServerStatus,
  };
});

export const useServerStatus = () => usePiniaRefStore(useServerStatusStore());
